// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.landlord.v1.leadmanagement.SatelliteWebLandlordLeadManagementHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  SatelliteWebLandlordApproveLeadRequestDto,
  SatelliteWebLandlordApproveLeadResponseDto,
  SatelliteWebLandlordGetScreeningCriteriaRequestDto,
  SatelliteWebLandlordGetScreeningCriteriaResponseDto,
  SatelliteWebLandlordLeadManagementSearchRequestDto,
  SatelliteWebLandlordLeadManagementSearchResponseDto,
  SatelliteWebLandlordLeadManagementStatsRequestDto,
  SatelliteWebLandlordLeadManagementStatsResponseDto,
  SatelliteWebLandlordLeadManagementTableRequestDto,
  SatelliteWebLandlordLeadManagementTableResponseDto,
  SatelliteWebLandlordMarkAsTenantRequestDto,
  SatelliteWebLandlordMarkAsTenantResponseDto,
  SatelliteWebLandlordSetScreeningCriteriaRequestDto,
} from '../..';

export const SatelliteWebLandlordLeadManagementHandler_approveLead_Path =
  '/api/web/landlord/v1/leadManagement/approveLead';

export const SatelliteWebLandlordLeadManagementHandler_approveLead = (
  postData: SatelliteWebLandlordApproveLeadRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordApproveLeadRequestDto,
    SatelliteWebLandlordApproveLeadResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordLeadManagementHandler_approveLead_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordLeadManagementHandler_getScreeningCriteria_Path =
  '/api/web/landlord/v1/leadManagement/getScreeningCriteria';

export const SatelliteWebLandlordLeadManagementHandler_getScreeningCriteria = (
  postData: SatelliteWebLandlordGetScreeningCriteriaRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordGetScreeningCriteriaRequestDto,
    SatelliteWebLandlordGetScreeningCriteriaResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordLeadManagementHandler_getScreeningCriteria_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordLeadManagementHandler_leadManagementSearch_Path =
  '/api/web/landlord/v1/leadManagement/leadManagementSearch';

export const SatelliteWebLandlordLeadManagementHandler_leadManagementSearch = (
  postData: SatelliteWebLandlordLeadManagementSearchRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordLeadManagementSearchRequestDto,
    SatelliteWebLandlordLeadManagementSearchResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordLeadManagementHandler_leadManagementSearch_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordLeadManagementHandler_leadManagementStats_Path =
  '/api/web/landlord/v1/leadManagement/leadManagementStats';

export const SatelliteWebLandlordLeadManagementHandler_leadManagementStats = (
  postData: SatelliteWebLandlordLeadManagementStatsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordLeadManagementStatsRequestDto,
    SatelliteWebLandlordLeadManagementStatsResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordLeadManagementHandler_leadManagementStats_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordLeadManagementHandler_leadManagementTable_Path =
  '/api/web/landlord/v1/leadManagement/leadManagementTable';

export const SatelliteWebLandlordLeadManagementHandler_leadManagementTable = (
  postData: SatelliteWebLandlordLeadManagementTableRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordLeadManagementTableRequestDto,
    SatelliteWebLandlordLeadManagementTableResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordLeadManagementHandler_leadManagementTable_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordLeadManagementHandler_markAsTenant_Path =
  '/api/web/landlord/v1/leadManagement/markAsTenant';

export const SatelliteWebLandlordLeadManagementHandler_markAsTenant = (
  postData: SatelliteWebLandlordMarkAsTenantRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordMarkAsTenantRequestDto,
    SatelliteWebLandlordMarkAsTenantResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordLeadManagementHandler_markAsTenant_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordLeadManagementHandler_setScreeningCriteria_Path =
  '/api/web/landlord/v1/leadManagement/setScreeningCriteria';

export const SatelliteWebLandlordLeadManagementHandler_setScreeningCriteria = (
  postData: SatelliteWebLandlordSetScreeningCriteriaRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SatelliteWebLandlordSetScreeningCriteriaRequestDto, void>(
    {
      endpoint: SatelliteWebLandlordLeadManagementHandler_setScreeningCriteria_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};
